export const defaultResources = {
  en: {
    common: {
      // Navigation
      contracts: 'Contracts',
      categories: 'Categories',
      contacts: 'Contacts',
      contractTypes: 'Contract Types',
      currencies: 'Currencies',
      
      // Actions
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      create: 'Create',
      update: 'Update',
      continue: 'Continue',
      assign: 'Assign',
      updating: 'Updating...',
      createAndAssign: 'Create & Assign',
      
      // States
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      saving: 'Saving...',
      
      // Contract related
      supplier: 'Supplier',
      expiryDate: 'Expiry Date',
      signedDate: 'Signed Date',
      category: 'Category',
      type: 'Type',
      importance: 'Importance',
      expectedCost: 'Expected Cost',
      expectedIncome: 'Expected Income',
      value: 'Value',
      currency: 'Currency',
      actions: 'Actions',
      status: 'Status',
      select: 'Select',
      contractType: 'Contract Type',
      paymentFrequency: 'Payment Frequency',
      oneTime: 'One time',
      
      // Contract table UI elements
      searchContracts: 'Search contracts...',
      resetFilters: 'Reset Filters',
      settings: 'Settings',
      updateAllRates: 'Update All Rates',
      newContract: 'New Contract',
      allContracts: 'All Contracts',
      showingXtoYofZ: 'Showing {{start}} to {{end}} of {{total}}',
      totalCost: 'Total cost: ',
      totalCostInCurrency: 'Total cost in {{currency}}: ',
      totalIncome: 'Total income: ',
      totalIncomeInCurrency: 'Total income in {{currency}}: ',
      result: 'Result: ',
      resultInCurrency: 'Result in {{currency}}: ',
      
      // Admin section
      adminDashboard: 'Admin Dashboard',
      translations: 'Translations',
      manageTranslations: 'Manage Translations',
      
      // User Management
      users: 'Users',
      manageUsers: 'Manage Users',
      createUser: 'Create User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      userCreated: 'User Created',
      userUpdated: 'User Updated',
      userDeleted: 'User Deleted',
      roles: 'Roles',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      name: 'Name',
      
      // Bug Reports
      bugReports: 'Bug Reports',
      manageBugReports: 'Manage Bug Reports',
      newBugReport: 'New Bug Report',
      bugReportDetails: 'Bug Report Details',
      statusChangeSuccess: 'Status Change Success',
      
      // Email Settings
      emailSettings: 'Email Settings',
      configureEmailSettings: 'Configure Email Settings',
      smtpHost: 'SMTP Host',
      smtpPort: 'SMTP Port',
      smtpUser: 'SMTP User',
      smtpPassword: 'SMTP Password',
      senderEmail: 'Sender Email',
      testEmail: 'Test Email',
      sendTestEmail: 'Send Test Email',
      testEmailSent: 'Test Email Sent',
      
      // System Settings
      systemSettings: 'System Settings',
      generalSettings: 'General Settings',
      defaultLanguage: 'Default Language',
      
      // Features Settings
      featuresSettings: 'Features Settings',
      enableFeature: 'Enable Feature',
      disableFeature: 'Disable Feature',
      
      // Company Register Settings
      companyRegisterSettings: 'Company Register Settings',
      companyName: 'Company Name',
      companyAddress: 'Company Address',
      companyLogo: 'Company Logo',
      
      // Widget Designer
      widgetDesigner: 'Widget Designer',
      designYourWidgets: 'Design Your Widgets',
      addWidget: 'Add Widget',
      editWidget: 'Edit Widget',
      deleteWidget: 'Delete Widget',
      widgetName: 'Widget Name',
      widgetType: 'Widget Type',
      widgetData: 'Widget Data',
      
      // Seed Translations
      seedTranslations: 'Seed Translations',
      seedTranslationsFromDefaults: 'Seed Translations From Defaults',
      seedingTranslations: 'Seeding Translations',
      translationsSeeded: 'Translations Seeded',
      
      // Translations Manager
      manageApplicationTranslations: 'Manage Application Translations',
      addNewLanguage: 'Add New Language',
      languageCode: 'Language Code',
      addLanguage: 'Add Language',
      languageCodeHelp: 'Enter a 2-letter language code (e.g., en, es, fr)',
      localeExists: 'Locale {{locale}} already exists',
      localeAdded: 'Locale {{locale}} added',
      addNewTranslationKey: 'Add New Translation Key',
      translationKeyPlaceholder: 'Enter translation key',
      valueForLocale: 'Value for {{locale}}',
      addTranslationKey: 'Add Translation Key',
      translationKeyHelp: 'Enter a unique key for the translation',
      translationUpdated: 'Translation for "{{key}}" in "{{locale}}" updated successfully',
      invalidKey: 'Invalid key',
      invalidLocaleCode: 'Invalid locale code',
      selectLanguage: 'Select Language',
      searchTranslationKeys: 'Search Translation Keys',
      translationKey: 'Translation Key',
      translationValue: 'Value',
      noResults: 'No Results',
      syncingTranslations: 'Syncing Translations',
      translationsSynced: 'Translations Synced',
      errorSyncingTranslations: 'Error Syncing Translations',
      
      // Contracts table UI elements
      manageYourContracts: 'Manage all your contracts in one place',
      areYouSure: 'Are you absolutely sure?',
      deleteContractsWarning: 'This action cannot be undone. This will permanently delete the selected contracts from our servers.',
      assignToGroup: 'Assign to Group',
      removeFromGroup: 'Remove from Group',
      tableSettings: 'Table Settings',
      configureContractsDisplay: 'Configure how the contracts are displayed',
      showGroupedContracts: 'Show Grouped Contracts',
      displayContractsInGroups: 'Display contracts in their assigned groups',
      columns: 'Columns',
      customizeColumns: 'Customize columns',
      selectOrCreateGroup: 'Select an existing group or create a new one to assign the selected contracts.',
      existingGroup: 'Existing Group',
      createNewGroup: 'Create New Group',
      selectAGroup: 'Select a group',
      noExistingGroups: 'No existing groups found. Create a new group instead.',
      groupName: 'Group Name',
      description: 'Description',
      optional: 'optional',
      enterGroupName: 'Enter group name',
      enterGroupDescription: 'Enter group description',
      
      // Exchange rates
      noCurrenciesAvailable: 'No currencies available',
      exchangeRatesUpdated: 'All exchange rates updated successfully',
      failedToUpdateRates: 'Failed to update exchange rates',
      currencyDisclaimer: 'Currency conversions are estimates and may not reflect exact rates at the time of contract payment.',
      
      // Dashboard page and widgets
      dashboard: {
        title: 'Dashboard',
        loading: 'Loading dashboard...',
        notAvailable: 'Dashboard Not Available',
        upgradeMessage: 'The advanced dashboard visualization is not included in your current subscription plan.',
        viewPlans: 'View Available Plans',
        upgradeDetails: 'Upgrade your plan to get access to all dashboard features including financial insights, contract timelines, distribution analytics, and more.',
        
        controls: {
          editLayout: 'Edit Layout',
          editing: 'Editing',
          addWidget: 'Add Widget',
          resetLayout: 'Reset Layout',
          saveLayout: 'Save Layout',
          saving: 'Saving...',
          saved: 'Saved!',
          freePositioning: 'Free Positioning',
          gridLayout: 'Grid Layout'
        },
        
        widgets: {
          noData: 'No contract data yet',
          populate: 'Your dashboard will populate with insights once you add contracts to the system.',
          addFirst: 'Add your first contract',
          
          totalContracts: 'Total Contracts',
          acrossCategories: 'Across all categories',
          activeContracts: 'Active Contracts',
          currentlyActive: 'Currently active',
          expiringSoon: 'Expiring Soon',
          nextDays: 'In the next 30 days',
          totalValue: 'Total Value',
          inUserCurrency: 'In user\'s currency',
          calculating: 'Calculating...',
          
          contractsByType: 'Contracts by Type',
          contractsTimeline: 'Contracts Timeline',
          hoverInfo: 'Hover over data points to see detailed information',
          contractCount: '{{value}} contracts',
          
          recentContracts: 'Recent Contracts',
          supplier: 'Supplier',
          status: 'Status',
          created: 'Created',
          actions: 'Actions',
          noRecentContracts: 'No recent contracts found',
          
          upcomingExpirations: 'Upcoming Expirations',
          expires: 'Expires',
          daysLeft: 'Days Left',
          noDaysLeft: '{{count}} days',
          noUpcomingExpirations: 'No upcoming expirations',
          
          contractCostsByType: 'Contract Costs by Type',
          financialResult: 'Financial Result',
          multiCurrency: 'Multi-currency conversion',
          convertedFrom: 'Converted from multiple currencies'
        }
      },
      
      // Contract view page translations
      back: 'Back',
      contractDetails: 'Contract Details',
      basicInformation: 'Basic Information',
      supplierDetails: 'Supplier Details',
      organizationNumber: 'Organization Number',
      renewalDate: 'Renewal Date',
      renewalTerms: 'Renewal Terms',
      autoRenews: 'Auto Renews',
      everyInterval: 'Every {{interval}} {{unit}}',
      viewTimeline: 'View Timeline',
      viewCostTimeline: 'View Cost Timeline',
      viewIncomeTimeline: 'View Income Timeline',
      manageContacts: 'Manage Contacts',
      noContacts: 'No contacts associated with this contract',
      peopleAssociated: 'People associated with this contract',
      contactPersons: 'Contact Persons',

      // Email related translations
      sendContract: 'Send Contract',
      recipient: 'Recipient',
      subject: 'Subject',
      message: 'Message',
      emailAddress: 'Email address',
      includeAdditionalAttachments: 'Include additional attachments',
      send: 'Send',
      sending: 'Sending...',
      generatingPdf: 'Generating PDF...',
      emailSent: 'Email sent successfully',
      errorSendingEmail: 'Error sending email',
      fillAllFields: 'Please fill all required fields',

      // Service Types
      serviceTypes: {
        product: 'Product',
        service: 'Service',
        subscription: 'Subscription',
        license: 'License',
        other: 'Other'
      },

      // Contract Services translations
      contractServices: 'Contract Services',
      servicesAssociated: 'Services associated with this contract',
      noServices: 'No services associated with this contract',
      serviceName: 'Service Name',
      serviceType: 'Service Type',
      quantity: 'Quantity',
      unitCost: 'Unit Cost',
      
      // Empty contracts state translations
      "contracts.emptyState.title": "Get Started with Contract Management",
      "contracts.emptyState.description": "Create your first contract to start organizing and managing your business agreements effectively.",
      "contracts.emptyState.addFirstContract": "Add Your First Contract",
      "contracts.emptyState.step1.title": "Enter Basic Details",
      "contracts.emptyState.step1.description": "Start by entering the supplier name and basic contract information.",
      "contracts.emptyState.step2.title": "Set Terms",
      "contracts.emptyState.step2.description": "Define contract terms including expiry date and expected costs.",
      "contracts.emptyState.step3.title": "Add Documents",
      "contracts.emptyState.step3.description": "Upload any relevant contract documents and files.",
      "contracts.emptyState.needHelp": "Need help? Check our",
      "contracts.emptyState.documentation": "documentation",
    }
  },
  es: {
    common: {
      // Navigation
      contracts: 'Contratos',
      categories: 'Categorías',
      contacts: 'Contactos',
      contractTypes: 'Tipos de Contrato',
      currencies: 'Monedas',
      
      // Actions
      add: 'Añadir',
      edit: 'Editar',
      delete: 'Eliminar',
      cancel: 'Cancelar',
      save: 'Guardar',
      create: 'Crear',
      update: 'Actualizar',
      continue: 'Continuar',
      assign: 'Asignar',
      updating: 'Actualizando...',
      createAndAssign: 'Crear y Asignar',
      
      // States
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      saving: 'Guardando...',
      
      // Contract related
      supplier: 'Proveedor',
      expiryDate: 'Fecha de Vencimiento',
      signedDate: 'Fecha de Firma',
      category: 'Categoría',
      type: 'Tipo',
      importance: 'Importancia',
      expectedCost: 'Costo Esperado',
      expectedIncome: 'Ingreso Esperado',
      value: 'Valor',
      currency: 'Moneda',
      actions: 'Acciones',
      status: 'Estado',
      select: 'Seleccionar',
      contractType: 'Tipo de Contrato',
      paymentFrequency: 'Frecuencia de Pago',
      oneTime: 'Una vez',
      
      // Contract table UI elements
      searchContracts: 'Buscar contratos...',
      resetFilters: 'Restablecer Filtros',
      settings: 'Configuración',
      updateAllRates: 'Actualizar Todas las Tasas',
      newContract: 'Nuevo Contrato',
      allContracts: 'Todos los Contratos',
      showingXtoYofZ: 'Mostrando {{start}} a {{end}} de {{total}}',
      totalCost: 'Costo total: ',
      totalCostInCurrency: 'Costo total en {{currency}}: ',
      totalIncome: 'Ingreso total: ',
      totalIncomeInCurrency: 'Ingreso total en {{currency}}: ',
      result: 'Resultado: ',
      resultInCurrency: 'Resultado en {{currency}}: ',
      
      // Admin section
      adminDashboard: 'Panel de Administración',
      translations: 'Traducciones',
      manageTranslations: 'Administrar Traducciones',
      
      // User Management
      users: 'Usuarios',
      manageUsers: 'Administrar Usuarios',
      createUser: 'Crear Usuario',
      editUser: 'Editar Usuario',
      deleteUser: 'Eliminar Usuario',
      userCreated: 'Usuario Creado',
      userUpdated: 'Usuario Actualizado',
      userDeleted: 'Usuario Eliminado',
      roles: 'Roles',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      name: 'Nombre',
      
      // Bug Reports
      bugReports: 'Informes de Errores',
      manageBugReports: 'Administrar Informes de Errores',
      newBugReport: 'Nuevo Informe de Error',
      bugReportDetails: 'Detalles del Informe de Error',
      statusChangeSuccess: 'Cambio de Estado Exitoso',
      
      // Email Settings
      emailSettings: 'Configuración de Correo Electrónico',
      configureEmailSettings: 'Configurar la Configuración de Correo Electrónico',
      smtpHost: 'Host SMTP',
      smtpPort: 'Puerto SMTP',
      smtpUser: 'Usuario SMTP',
      smtpPassword: 'Contraseña SMTP',
      senderEmail: 'Correo Electrónico del Remitente',
      testEmail: 'Correo Electrónico de Prueba',
      sendTestEmail: 'Enviar Correo Electrónico de Prueba',
      testEmailSent: 'Correo Electrónico de Prueba Enviado',
      
      // System Settings
      systemSettings: 'Configuración del Sistema',
      generalSettings: 'Configuración General',
      defaultLanguage: 'Idioma Predeterminado',
      
      // Features Settings
      featuresSettings: 'Configuración de Características',
      enableFeature: 'Habilitar Característica',
      disableFeature: 'Deshabilitar Característica',
      
      // Company Register Settings
      companyRegisterSettings: 'Configuración del Registro de la Empresa',
      companyName: 'Nombre de la Empresa',
      companyAddress: 'Dirección de la Empresa',
      companyLogo: 'Logotipo de la Empresa',
      
      // Widget Designer
      widgetDesigner: 'Diseñador de Widgets',
      designYourWidgets: 'Diseña Tus Widgets',
      addWidget: 'Agregar Widget',
      editWidget: 'Editar Widget',
      deleteWidget: 'Eliminar Widget',
      widgetName: 'Nombre del Widget',
      widgetType: 'Tipo de Widget',
      widgetData: 'Datos del Widget',
      
      // Seed Translations
      seedTranslations: 'Sembrar Traducciones',
      seedTranslationsFromDefaults: 'Sembrar Traducciones de los Valores Predeterminados',
      seedingTranslations: 'Sembrando Traducciones',
      translationsSeeded: 'Traducciones Sembradas',
      
      // Translations Manager
      manageApplicationTranslations: 'Administrar Traducciones de la Aplicación',
      addNewLanguage: 'Agregar Nuevo Idioma',
      languageCode: 'Código de Idioma',
      addLanguage: 'Agregar Idioma',
      languageCodeHelp: 'Ingrese un código de idioma de 2 letras (por ejemplo, en, es, fr)',
      localeExists: 'El idioma {{locale}} ya existe',
      localeAdded: 'Idioma {{locale}} agregado',
      addNewTranslationKey: 'Agregar Nueva Clave de Traducción',
      translationKeyPlaceholder: 'Ingrese la clave de traducción',
      valueForLocale: 'Valor para {{locale}}',
      addTranslationKey: 'Agregar Clave de Traducción',
      translationKeyHelp: 'Ingrese una clave única para la traducción',
      translationUpdated: 'Traducción para "{{key}}" en "{{locale}}" actualizada con éxito',
      invalidKey: 'Clave inválida',
      invalidLocaleCode: 'Código de idioma inválido',
      selectLanguage: 'Seleccionar Idioma',
      searchTranslationKeys: 'Buscar Claves de Traducción',
      translationKey: 'Clave de Traducción',
      translationValue: 'Valor',
      noResults: 'Sin Resultados',
      syncingTranslations: 'Sincronizando Traducciones',
      translationsSynced: 'Traducciones Sincronizadas',
      errorSyncingTranslations: 'Error al Sincronizar Traducciones',
      
      // Contracts table UI elements
      manageYourContracts: 'Administre todos sus contratos en un solo lugar',
      areYouSure: '¿Está absolutamente seguro?',
      deleteContractsWarning: 'Esta acción no se puede deshacer. Esto eliminará permanentemente los contratos seleccionados de nuestros servidores.',
      assignToGroup: 'Asignar a Grupo',
      removeFromGroup: 'Quitar del Grupo',
      tableSettings: 'Configuración de Tabla',
      configureContractsDisplay: 'Configure cómo se muestran los contratos',
      showGroupedContracts: 'Mostrar Contratos Agrupados',
      displayContractsInGroups: 'Mostrar contratos en sus grupos asignados',
      columns: 'Columnas',
      customizeColumns: 'Personalizar columnas',
      selectOrCreateGroup: 'Seleccione un grupo existente o cree uno nuevo para asignar los contratos seleccionados.',
      existingGroup: 'Grupo Existente',
      createNewGroup: 'Crear Nuevo Grupo',
      selectAGroup: 'Seleccione un grupo',
      noExistingGroups: 'No se encontraron grupos existentes. Cree un nuevo grupo en su lugar.',
      groupName: 'Nombre del Grupo',
      description: 'Descripción',
      optional: 'opcional',
      enterGroupName: 'Ingrese el nombre del grupo',
      enterGroupDescription: 'Ingrese la descripción del grupo',
      
      // Exchange rates
      noCurrenciesAvailable: 'No hay monedas disponibles',
      exchangeRatesUpdated: 'Todas las tasas de cambio actualizadas con éxito',
      failedToUpdateRates: 'Error al actualizar las tasas de cambio',
      currencyDisclaimer: 'Las conversiones de divisas son estimaciones y pueden no reflejar los tipos de cambio exactos en el momento del pago del contrato.',
      
      // Dashboard page and widgets
      dashboard: {
        title: 'Panel',
        loading: 'Cargando panel...',
        notAvailable: 'Panel No Disponible',
        upgradeMessage: 'La visualización avanzada del panel no está incluida en su plan de suscripción actual.',
        viewPlans: 'Ver Planes Disponibles',
        upgradeDetails: 'Actualice su plan para obtener acceso a todas las funciones del panel, incluidos los conocimientos financieros, las líneas de tiempo de los contratos, los análisis de distribución y más.',
        
        controls: {
          editLayout: 'Editar Diseño',
          editing: 'Editando',
          addWidget: 'Agregar Widget',
          resetLayout: 'Restablecer Diseño',
          saveLayout: 'Guardar Diseño',
          saving: 'Guardando...',
          saved: '¡Guardado!',
          freePositioning: 'Posicionamiento Libre',
          gridLayout: 'Diseño en Cuadrícula'
        },
        
        widgets: {
          noData: 'Aún no hay datos de contratos',
          populate: 'Su panel se completará con información una vez que agregue contratos al sistema.',
          addFirst: 'Agregue su primer contrato',
          
          totalContracts: 'Contratos Totales',
          acrossCategories: 'En todas las categorías',
          activeContracts: 'Contratos Activos',
          currentlyActive: 'Actualmente activos',
          expiringSoon: 'Vencen Pronto',
          nextDays: 'En los próximos 30 días',
          totalValue: 'Valor Total',
          inUserCurrency: 'En la moneda del usuario',
          calculating: 'Calculando...',
          
          contractsByType: 'Contratos por Tipo',
          contractsTimeline: 'Línea de Tiempo de Contratos',
          hoverInfo: 'Pase el cursor sobre los puntos de datos para ver información detallada',
          contractCount: '{{value}} contratos',
          
          recentContracts: 'Contratos Recientes',
          supplier: 'Proveedor',
          status: 'Estado',
          created: 'Creado',
          actions: 'Acciones',
          noRecentContracts: 'No se encontraron contratos recientes',
          
          upcomingExpirations: 'Próximos Vencimientos',
          expires: 'Vence',
          daysLeft: 'Días Restantes',
          noDaysLeft: '{{count}} días',
          noUpcomingExpirations: 'No hay vencimientos próximos',
          
          contractCostsByType: 'Costos de Contratos por Tipo',
          financialResult: 'Resultado Financiero',
          multiCurrency: 'Conversión de múltiples divisas',
          convertedFrom: 'Convertido de múltiples divisas'
        }
      },
      
      // Contract view page translations
      back: 'Volver',
      contractDetails: 'Detalles del Contrato',
      basicInformation: 'Información Básica',
      supplierDetails: 'Detalles del Proveedor',
      organizationNumber: 'Número de Organización',
      renewalDate: 'Fecha de Renovación',
      renewalTerms: 'Términos de Renovación',
      autoRenews: 'Renovación Automática',
      everyInterval: 'Cada {{interval}} {{unit}}',
      viewTimeline: 'Ver Línea de Tiempo',
      viewCostTimeline: 'Ver Línea de Tiempo de Costos',
      viewIncomeTimeline: 'Ver Línea de Tiempo de Ingresos',
      manageContacts: 'Gestionar Contactos',
      noContacts: 'No hay contactos asociados a este contrato',
      peopleAssociated: 'Personas asociadas a este contrato',
      contactPersons: 'Personas de Contacto',

      // Email related translations
      sendContract: 'Enviar Contrato',
      recipient: 'Destinatario',
      subject: 'Asunto',
      message: 'Mensaje',
      emailAddress: 'Dirección de correo',
      includeAdditionalAttachments: 'Incluir archivos adicionales',
      send: 'Enviar',
      sending: 'Enviando...',
      generatingPdf: 'Generando PDF...',
      emailSent: 'Correo enviado exitosamente',
      errorSendingEmail: 'Error al enviar el correo',
      fillAllFields: 'Por favor complete todos los campos requeridos',

      // Service Types
      serviceTypes: {
        product: 'Producto',
        service: 'Servicio',
        subscription: 'Suscripción',
        license: 'Licencia',
        other: 'Otro'
      },

      // Contract Services translations
      contractServices: 'Servicios del Contrato',
      servicesAssociated: 'Servicios asociados a este contrato',
      noServices: 'No hay servicios asociados a este contrato',
      serviceName: 'Nombre del Servicio',
      serviceType: 'Tipo de Servicio',
      quantity: 'Cantidad',
      unitCost: 'Costo Unitario',
      
      // Empty contracts state translations
      "contracts.emptyState.title": "Comience con la Gestión de Contratos",
      "contracts.emptyState.description": "Cree su primer contrato para comenzar a organizar y gestionar sus acuerdos comerciales de manera efectiva.",
      "contracts.emptyState.addFirstContract": "Agregar Su Primer Contrato",
      "contracts.emptyState.step1.title": "Ingrese los Detalles Básicos",
      "contracts.emptyState.step1.description": "Comience ingresando el nombre del proveedor y la información básica del contrato.",
      "contracts.emptyState.step2.title": "Establecer Términos",
      "contracts.emptyState.step2.description": "Defina los términos del contrato, incluida la fecha de vencimiento y los costos esperados.",
      "contracts.emptyState.step3.title": "Agregar Documentos",
      "contracts.emptyState.step3.description": "Suba cualquier documento relevante del contrato.",
      "contracts.emptyState.needHelp": "¿Necesita ayuda? Consulte nuestra",
      "contracts.emptyState.documentation": "documentación",
    }
  },
  no: {
    common: {
      // Navigation
      contracts: 'Kontrakter',
      categories: 'Kategorier',
      contacts: 'Kontakter',
      contractTypes: 'Kontraktstyper',
      currencies: 'Valutaer',
      
      // Actions
      add: 'Legg til',
      edit: 'Rediger',
      delete: 'Slett',
      cancel: 'Avbryt',
      save: 'Lagre',
      create: 'Opprett',
      update: 'Oppdater',
      continue: 'Fortsett',
      assign: 'Tildel',
      updating: 'Oppdaterer...',
      createAndAssign: 'Opprett og Tildel',
      
      // States
      loading: 'Laster...',
      error: 'Feil',
      success: 'Vellykket',
      saving: 'Lagrer...',
      
      // Contract related
      supplier: 'Leverandør',
      expiryDate: 'Utløpsdato',
      signedDate: 'Signeringsdato',
      category: 'Kategori',
      type: 'Type',
      importance: 'Viktighet',
      expectedCost: 'Forventet kostnad',
      expectedIncome: 'Forventet inntekt',
      value: 'Verdi',
      currency: 'Valuta',
      actions: 'Handlinger',
      status: 'Status',
      select: 'Velg',
      contractType: 'Kontraktstype',
      paymentFrequency: 'Betalingsfrekvens',
      oneTime: 'Én gang',
      
      // Contract table UI elements
      searchContracts: 'Søk i kontrakter...',
      resetFilters: 'Tilbakestill Filtre',
      settings: 'Innstillinger',
      updateAllRates: 'Oppdater Alle Kurser',
      newContract: 'Ny Kontrakt',
      allContracts: 'Alle Kontrakter',
      showingXtoYofZ: 'Viser {{start}} til {{end}} av {{total}}',
      totalCost: 'Total kostnad: ',
      totalCostInCurrency: 'Total kostnad i {{currency}}: ',
      totalIncome: 'Total inntekt: ',
      totalIncomeInCurrency: 'Total inntekt i {{currency}}: ',      
      result: 'Resultat: ',
      resultInCurrency: 'Resultat i {{currency}}: ',      
      
      // Admin section
      adminDashboard: 'Admin Dashboard',
      translations: 'Oversettelser',
      manageTranslations: 'Administrer Oversettelser',
      
      // User Management
      users: 'Brukere',
      manageUsers: 'Administrer Brukere',
      createUser: 'Opprett Bruker',
      editUser: 'Rediger Bruker',
      deleteUser: 'Slett Bruker',
      userCreated: 'Bruker Opprettet',
      userUpdated: 'Bruker Oppdatert',
      userDeleted: 'Bruker Slettet',
      roles: 'Roller',
      email: 'Epost',
      password: 'Passord',
      confirmPassword: 'Bekreft Passord',
      name: 'Navn',
      
      // Bug Reports
      bugReports: 'Feilrapporter',
      manageBugReports: 'Administrer Feilrapporter',
      newBugReport: 'Ny Feilrapport',
      bugReportDetails: 'Feilrapport Detaljer',
      statusChangeSuccess: 'Status Endring Suksess',
      
      // Email Settings
      emailSettings: 'Epostinnstillinger',
      configureEmailSettings: 'Konfigurer Epostinnstillinger',
      smtpHost: 'SMTP Host',
      smtpPort: 'SMTP Port',
      smtpUser: 'SMTP Bruker',
      smtpPassword: 'SMTP Passord',
      senderEmail: 'Avsender Epost',
      testEmail: 'Test Epost',
      sendTestEmail: 'Send Test Epost',
      testEmailSent: 'Test Epost Sendt',
      
      // System Settings
      systemSettings: 'Systeminnstillinger',
      generalSettings: 'Generelle Innstillinger',
      defaultLanguage: 'Standard Språk',
      
      // Features Settings
      featuresSettings: 'Funksjonsinnstillinger',
      enableFeature: 'Aktiver Funksjon',
      disableFeature: 'Deaktiver Funksjon',
      
      // Company Register Settings
      companyRegisterSettings: 'Firma Register Innstillinger',
      companyName: 'Firmanavn',
      companyAddress: 'Firmaadresse',
      companyLogo: 'Firmalogo',
      
       // Widget Designer
      widgetDesigner: 'Widget Designer',
      designYourWidgets: 'Design Dine Widgets',
      addWidget: 'Legg til Widget',
      editWidget: 'Rediger Widget',
      deleteWidget: 'Slett Widget',
      widgetName: 'Widget Navn',
      widgetType: 'Widget Type',
      widgetData: 'Widget Data',
      
      // Seed Translations
      seedTranslations: 'Seed Oversettelser',
      seedTranslationsFromDefaults: 'Seed Oversettelser Fra Standarder',
      seedingTranslations: 'Seeding Oversettelser',
      translationsSeeded: 'Oversettelser Seeded',
      
      // Translations Manager
      manageApplicationTranslations: 'Administrer Applikasjon Oversettelser',
      addNewLanguage: 'Legg Til Nytt Språk',
      languageCode: 'Språkkode',
      addLanguage: 'Legg Til Språk',
      languageCodeHelp: 'Skriv inn en 2-bokstavs språkkode (f.eks. en, es, fr)',
      localeExists: 'Locale {{locale}} eksisterer allerede',
      localeAdded: 'Locale {{locale}} lagt til',
      addNewTranslationKey: 'Legg Til Ny Oversettelsesnøkkel',
      translationKeyPlaceholder: 'Skriv inn oversettelsesnøkkel',
      valueForLocale: 'Verdi for {{locale}}',
      addTranslationKey: 'Legg Til Oversettelsesnøkkel',
      translationKeyHelp: 'Skriv inn en unik nøkkel for oversettelsen',
      translationUpdated: 'Oversettelse for "{{key}}" i "{{locale}}" oppdatert',
      invalidKey: 'Ugyldig nøkkel',
      invalidLocaleCode: 'Ugyldig språkkode',
      selectLanguage: 'Velg Språk',
      searchTranslationKeys: 'Søk Oversettelsesnøkler',
      translationKey: 'Oversettelsesnøkkel',
      translationValue: 'Verdi',
      noResults: 'Ingen Resultater',
      syncingTranslations: 'Synkroniserer Oversettelser',
      translationsSynced: 'Oversettelser Synkronisert',
      errorSyncingTranslations: 'Feil ved Synkronisering av Oversettelser',
      
      // Contracts table UI elements
      manageYourContracts: 'Administrer alle kontraktene dine på ett sted',
      areYouSure: 'Er du helt sikker?',
      deleteContractsWarning: 'Denne handlingen kan ikke angres. Dette vil permanent slette de valgte kontraktene fra våre servere.',
      assignToGroup: 'Tildel til Gruppe',
      removeFromGroup: 'Fjern fra Gruppe',
      tableSettings: 'Tabellinnstillinger',
      configureContractsDisplay: 'Konfigurer hvordan kontraktene vises',
      showGroupedContracts: 'Vis Grupperte Kontrakter',
      displayContractsInGroups: 'Vis kontrakter i deres tildelte grupper',
      columns: 'Kolonner',
      customizeColumns: 'Tilpass kolonner',
      selectOrCreateGroup: 'Velg en eksisterende gruppe eller opprett en ny for å tildele de valgte kontraktene.',
      existingGroup: 'Eksisterende Gruppe',
      createNewGroup: 'Opprett Ny Gruppe',
      selectAGroup: 'Velg en gruppe',
      noExistingGroups: 'Ingen eksisterende grupper funnet. Opprett en ny gruppe i stedet.',
      groupName: 'Gruppenavn',
      description: 'Beskrivelse',
      optional: 'valgfri',
      enterGroupName: 'Skriv inn gruppenavn',
      enterGroupDescription: 'Skriv inn gruppebeskrivelse',
      
      // Exchange rates
      noCurrenciesAvailable: 'Ingen valutaer tilgjengelig',
      exchangeRatesUpdated: 'Alle valutakurser oppdatert',
      failedToUpdateRates: 'Kunne ikke oppdatere valutakurser',
      currencyDisclaimer: 'Valutakonverteringer er estimater og gjenspeiler kanskje ikke nøyaktige kurser på tidspunktet for kontraktsbetaling.',
      
      // Dashboard page and widgets
      dashboard: {
        title: 'Dashboard',
        loading: 'Laster dashboard...',
        notAvailable: 'Dashboard Ikke Tilgjengelig',
        upgradeMessage: 'Den avanserte dashboardvisualiseringen er ikke inkludert i ditt nåværende abonnement.',
        viewPlans: 'Se Tilgjengelige Planer',
        upgradeDetails: 'Oppgrader planen din for å få tilgang til alle dashbordfunksjoner, inkludert økonomisk innsikt, kontrakttidslinjer, distribusjonsanalyse og mer.',
        
        controls: {
          editLayout: 'Rediger Oppsett',
          editing: 'Redigerer',
          addWidget: 'Legg til Widget',
          resetLayout: 'Tilbakestill Oppsett',
          saveLayout: 'Lagre Oppsett',
          saving: 'Lagrer...',
          saved: 'Lagret!',
          freePositioning: 'Fri Posisjonering',
          gridLayout: 'Rutenettlayout'
        },
        
        widgets: {
          noData: 'Ingen kontraktsdata ennå',
          populate: 'Dashbordet ditt vil fylles med innsikt når du legger til kontrakter i systemet.',
          addFirst: 'Legg til din første kontrakt',
          
          totalContracts: 'Totale Kontrakter',
          acrossCategories: 'På tvers av alle kategorier',
          activeContracts: 'Aktive Kontrakter',
          currentlyActive: 'Nåværende aktive',
          expiringSoon: 'Utløper Snart',
          nextDays: 'I løpet av de neste 30 dagene',
          totalValue: 'Total Verdi',
          inUserCurrency: 'I brukerens valuta',
          calculating: 'Kalkulerer...',
          
          contractsByType: 'Kontrakter etter Type',
          contractsTimeline: 'Kontraktstidslinje',
          hoverInfo: 'Hold musepekeren over datapunkter for å se detaljert informasjon',
          contractCount: '{{value}} kontrakter',
          
          recentContracts: 'Nylige Kontrakter',
          supplier: 'Leverandør',
          status: 'Status',
          created: 'Opprettet',
          actions: 'Handlinger',
          noRecentContracts: 'Ingen nylige kontrakter funnet',
          
          upcomingExpirations: 'Kommende Utløp',
          expires: 'Utløper',
          daysLeft: 'Dager Igjen',
          noDaysLeft: '{{count}} dager',
          noUpcomingExpirations: 'Ingen kommende utløp',
          
          contractCostsByType: 'Kontraktskostnader etter Type',
          financialResult: 'Finansielt Resultat',
          multiCurrency: 'Flervaluta-konvertering',
          convertedFrom: 'Konvertert fra flere valutaer'
        }
      },
      
      // Contract view page translations
      back: 'Tilbake',
      contractDetails: 'Kontraktsdetaljer',
      basicInformation: 'Grunnleggende Informasjon',
      supplierDetails: 'Leverandørdetaljer',
      organizationNumber: 'Organisasjonsnummer',
      renewalDate: 'Fornyelses Dato',
      renewalTerms: 'Fornyelsesvilkår',
      autoRenews: 'Automatisk Fornying',
      everyInterval: 'Hver {{interval}} {{unit}}',
      viewTimeline: 'Vis Tidslinje',
      viewCostTimeline: 'Vis Kostnadstidslinje',
      viewIncomeTimeline: 'Vis Inntektstidslinje',
      manageContacts: 'Administrer Kontakter',
      noContacts: 'Ingen kontakter tilknyttet denne kontrakten',
      peopleAssociated: 'Personer tilknyttet denne kontrakten',
      contactPersons: 'Kontaktpersoner',

      // Email related translations
      sendContract: 'Send Kontrakt',
      recipient: 'Mottaker',
      subject: 'Emne',
      message: 'Melding',
      emailAddress: 'E-postadresse',
      includeAdditionalAttachments: 'Inkluder tilleggsfiler',
      send: 'Send',
      sending: 'Sender...',
      generatingPdf: 'Genererer PDF...',
      emailSent: 'E-post sendt',
      errorSendingEmail: 'Feil ved sending av e-post',
      fillAllFields: 'Vennligst fyll ut alle påkrevde felt',

      // Service Types
      serviceTypes: {
        product: 'Produkt',
        service: 'Tjeneste',
        subscription: 'Abonnement',
        license: 'Lisens',
        other: 'Annet'
      },

      // Contract Services translations
      contractServices: 'Kontraktstjenester',
      servicesAssociated: 'Tjenester tilknyttet denne kontrakten',
      noServices: 'Ingen tjenester tilknyttet denne kontrakten',
      serviceName: 'Tjenestenavn',
      serviceType: 'Tjenestetype',
      quantity: 'Antall',
      unitCost: 'Enhetskostnad',
      
      // Empty contracts state translations
      "contracts.emptyState.title": "Kom i gang med Kontraktsstyring",
      "contracts.emptyState.description": "Opprett din første kontrakt for å begynne å organisere og administrere dine forretningsavtaler effektivt.",
      "contracts.emptyState.addFirstContract": "Legg til din første kontrakt",
      "contracts.emptyState.step1.title": "Skriv inn grunnleggende detaljer",
      "contracts.emptyState.step1.description": "Start med å skrive inn leverandørnavn og grunnleggende kontraktsinformasjon.",
      "contracts.emptyState.step2.title": "Sett vilkår",
      "contracts.emptyState.step2.description": "Definer kontraktsvilkår inkludert utløpsdato og forventede kostnader.",
      "contracts.emptyState.step3.title": "Legg til dokumenter",
      "contracts.emptyState.step3.description": "Last opp relevante kontraktsdokumenter og filer.",
      "contracts.emptyState.needHelp": "Trenger du hjelp? Sjekk vår",
      "contracts.emptyState.documentation": "dokumentasjon"
    }
  }
};
